/** Normalize status/route type for shipment tracking tab eligibility. */
export const normalizeShipmentTrackingStatus = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

const SHIPMENT_TRACKING_STATUS_KEYS = new Set([
  "intransit",
  "delivered",
  "customerdeliverypending",
]);

export const isShipmentTrackingStatus = (value) =>
  SHIPMENT_TRACKING_STATUS_KEYS.has(normalizeShipmentTrackingStatus(value));

/**
 * Shipment Tracking tab: channel "02", or In-transit / Delivered / Customer Delivery Pending.
 */
export const isShipmentTrackingEligible = ({
  distributionChannel = null,
  routeType = "",
  orderStatus = "",
} = {}) => {
  if (distributionChannel === "02") {
    return true;
  }

  return (
    isShipmentTrackingStatus(routeType) || isShipmentTrackingStatus(orderStatus)
  );
};
